import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ApiServiceService } from "../../api-service.service";
import { NbToastrService } from "@nebular/theme";

@Component({
  selector: "ngx-resetpassword",
  templateUrl: "./resetpassword.component.html",
  styleUrls: ["./resetpassword.component.scss"],
})
export class ResetpasswordComponent implements OnInit {
  UserID: number;
  newPassword: string = "";
  successMessage: string = "";
  confirmPassword: string = "";
  errorMessage: string = "";
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private router: Router,
    private apiService: ApiServiceService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.UserID = params["UserID"];
    });
  }
  submitForm(resetPasswordForm: any) {
    if (resetPasswordForm.invalid) {
      this.errorMessage = "Please fill out all required fields.";
      return;
    }

    if (this.newPassword !== this.confirmPassword) {
      this.errorMessage = "Passwords do not match.";
      return;
    }

    const formdata = {
      UserID: this.UserID,
      Password: this.newPassword,
    };

    this.apiService.adminResetPassword(formdata).subscribe(
      (response: any) => {
        this.successMessage = "Password reset successfully";
        this.errorMessage = ""; // Clear error message if any
        setTimeout(() => {
          this.router.navigate(["/auth"]);
        }, 3000);
      },
      (error: any) => {
        console.error("Failed to reset password:", error);
        this.errorMessage = "Failed to reset password. Please try again later.";
        this.successMessage = "";
      }
    );
  }

  cancel() {
    this.router.navigate(["/auth"]);
  }

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}
